import React from 'react'
import { animateScroll as scroll } from 'react-scroll'
import { FaInstagram, FaYoutube, FaDiscord, FaTwitch } from 'react-icons/fa'
import
{
    FooterContainer,
    FooterWrap,
    FooterLinksContainer,
    FooterLinksWrapper,
    FooterLinkItems,
    FooterLinkTitle,
    FooterLink,
    SocialMedia,
    SocialMediaWrap,
    SocialLogo,
    WebsiteRights,
    WebsiteAuthor,
    SocialIcons,
    SocialIconLink
} from './FooterElements'


const Footer = () => {
    const toggleHome = () => {
        scroll.scrollToTop()
    }
  return (
    <FooterContainer>
        <FooterWrap>
            {/* <FooterLinksContainer>
                <FooterLinksWrapper>
                    <FooterLinkItems>
                        <FooterLinkTitle>About</FooterLinkTitle>
                        <FooterLink href="https://twitch.tv/valgraen">Twitch</FooterLink>
                    </FooterLinkItems>
                </FooterLinksWrapper>
            </FooterLinksContainer> */}

             <SocialMedia>
                <SocialMediaWrap>
                    <SocialLogo to='/' onClick={toggleHome}>
                        Valgraen
                    </SocialLogo>
                    <WebsiteRights>Valgraen © {new Date().getFullYear()} All rights reserved. Originally made by <WebsiteAuthor href="https://www.linkedin.com/in/david-z%C3%A1bransk%C3%BD-1a0238185/">David Zábranský</WebsiteAuthor></WebsiteRights>
                    <SocialIcons>
                        <SocialIconLink href="//www.twitch.tv/valgraen" target="_blank" aria-label="Twitch">
                            <FaTwitch />
                        </SocialIconLink>

                        <SocialIconLink href="//www.instagram.com/valgraen/" target="_blank" aria-label="Instagram">
                            <FaInstagram />
                        </SocialIconLink>

                        <SocialIconLink href="//www.discord.gg/hG7PwDm" target="_blank" aria-label="Discord">
                            <FaDiscord />
                        </SocialIconLink>

                        <SocialIconLink href="//www.youtube.com/channel/UC89OysybmzhHI_xJqIOXX8Q" target="_blank" aria-label="Youtube">
                            <FaYoutube />
                        </SocialIconLink>
                    </SocialIcons>

                </SocialMediaWrap>
             </SocialMedia>

        </FooterWrap>
    </FooterContainer>
  )
}

export default Footer